module.exports = __webpack_public_path__ + "static/college-15d6dd122adb4e76eb2c6116a4f358e4.jpg";